import { ICurrentUser, IAPICurrentUser } from '../interface/ICurrentUser'

export const currentUserTransformer = (
  endPointData: IAPICurrentUser,
): ICurrentUser => ({

  avatar: endPointData.attributes.avatar,
  establishmentId: endPointData.attributes.establishment_id,
  firstName: endPointData.attributes.first_name,
  id: endPointData.attributes.id,
  isActive: endPointData.attributes.is_active,
  lastName: endPointData.attributes.last_name,
  permissions: {
    hasAccessToSettings:
      endPointData.attributes.permissions.has_access_to_settings,
    hrAbsencesManage:
      endPointData.attributes.permissions.hr_absences_manage,
    hrTargetsManage: endPointData.attributes.permissions.hr_targets_manage,
    isVisibleInCalendar:
      endPointData.attributes.permissions.is_visible_in_calendar,
    isVisibleOnline: endPointData.attributes.permissions.is_visible_online,
  },
  uuid: endPointData.attributes.uuid,
  type: endPointData.type,
  email: endPointData.attributes.email,
})
